import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Avatar from "./Avatar";
import { PlusCircle } from "lucide-react";

export default function CreatePostCard() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="bg-[#121212] border border-[#262626] p-4 rounded-sm">
      <div className="flex items-center gap-3">
        <Avatar url={user.avatar_url} name={user.name} size={44} />
        <Link
          to="/create"
          data-testid="create-post-cta"
          className="flex-1 bg-[#0a0a0a] border border-[#262626] hover:border-[#404040] px-4 py-3 rounded-full text-left text-sm text-[#737373] transition-colors"
        >
          Share your last match, {user.name?.split(" ")[0]}…
        </Link>
      </div>
      <div className="flex items-center justify-end mt-3">
        <Link
          to="/create"
          data-testid="create-post-btn"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white bg-white/10 hover:bg-white/20 px-3 py-2 rounded-sm transition-colors"
        >
          <PlusCircle className="w-4 h-4" /> Post match
        </Link>
      </div>
    </div>
  );
}
